export const SET_SNACK_BAR_DATA = 'SAVE_SNACK_BAR_DATA';
